import React from 'react';
import PropTypes from 'prop-types';

const IconDownload = props => {
  const { height, width, className } = props;

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <title>Download icon</title>
      <path d="M24.615 27.076c0-0.673-0.558-1.231-1.231-1.231s-1.231 0.558-1.231 1.231 0.558 1.231 1.231 1.231 1.231-0.558 1.231-1.231zM29.538 27.076c0-0.673-0.558-1.231-1.231-1.231s-1.231 0.558-1.231 1.231 0.558 1.231 1.231 1.231 1.231-0.558 1.231-1.231zM31.999 22.769v6.154c0 1.019-0.827 1.846-1.846 1.846h-28.306c-1.019 0-1.846-0.827-1.846-1.846v-6.154c0-1.019 0.827-1.846 1.846-1.846h8.942l2.596 2.615c0.712 0.692 1.635 1.077 2.615 1.077s1.904-0.385 2.615-1.077l2.615-2.615h8.923c1.019 0 1.846 0.827 1.846 1.846zM25.749 11.827c0.192 0.461 0.096 1-0.269 1.346l-8.615 8.615c-0.231 0.25-0.558 0.365-0.865 0.365s-0.635-0.115-0.865-0.365l-8.615-8.615c-0.365-0.346-0.462-0.885-0.269-1.346 0.192-0.442 0.635-0.75 1.135-0.75h4.923v-8.615c0-0.673 0.558-1.231 1.231-1.231h4.923c0.673 0 1.231 0.558 1.231 1.231v8.615h4.923c0.5 0 0.942 0.308 1.135 0.75z" />
    </svg>
  );
};

IconDownload.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

IconDownload.defaultProps = {
  height: 32,
  width: 32,
  className: '',
};

export default IconDownload;



// WEBPACK FOOTER //
// ./src/components/Icon/svg/Download.js